module.exports = __webpack_public_path__ + "img/w18-b3.5e0a229d.jpg";